import classNames from 'classnames';

import { makePrezlyLinkRelative } from '@/util/seo/makePrezlyLinkRelative';

import { parseFieldValue } from '../util';

import styles from './GenericTable.module.scss';

interface Props {
    columns: string[];
    row: Record<string, string>;
    selectedColumn?: string;
}

export function Field({ columns, row, selectedColumn }: Props) {
    function getColumnKey(key: string) {
        return `Column ${key}`;
    }

    return (
        <div className={styles.row}>
            <div className={styles['name--desktop']}>
                <div className={styles.tooltip}>
                    {row.Link?.length ? (
                        <a href={makePrezlyLinkRelative(row.Link)} className={styles.link}>
                            {row['Feature Name']}
                        </a>
                    ) : (
                        row['Feature Name']
                    )}

                    {Boolean(row.Tooltip?.length) && (
                        <div className={styles.tooltipContent}>{row.Tooltip}</div>
                    )}
                </div>
            </div>
            <div className={styles['name--mobile']}>
                {row.Link?.length ? (
                    <a href={makePrezlyLinkRelative(row.Link)}>{row['Feature Name']}</a>
                ) : (
                    row['Feature Name']
                )}
            </div>
            <div className={styles.values}>
                {columns.map((column) => {
                    const { Icon, text } = parseFieldValue(row[getColumnKey(column)]);

                    return (
                        <div
                            key={column}
                            className={classNames(styles.value, {
                                [styles['value--showOnMobile']]: selectedColumn === column,
                            })}
                        >
                            {Icon && <Icon width={15} height={15} />} {text}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
